module.exports = __webpack_public_path__ + "img/icon-dots-vertical.9020d255.svg";